import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { apiUrl } from '@/api/client';
import { receiptKindFromFile } from '@/lib/receipt-file';
import { ReceiptImageViewer } from './ReceiptImageViewer';
import { ReceiptPdfViewer } from './ReceiptPdfViewer';
import type { ExpenseWithDetails } from '@jobos/shared';

interface ReceiptViewerDialogProps {
  /** Expense whose receipt to display, or null when closed. */
  expense: ExpenseWithDetails | null;
  onOpenChange: (open: boolean) => void;
}

export function ReceiptViewerDialog({ expense, onOpenChange }: ReceiptViewerDialogProps) {
  const open = expense != null && expense.fileId != null;
  const src = expense ? apiUrl(`/expenses/${expense.id}/receipt`) : '';
  const kind = expense ? receiptKindFromFile(expense.file) : 'image';
  const label = expense ? `Receipt — ${expense.storeName}` : 'Receipt';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* A receipt is read by zooming into it, so on a phone it takes the whole
          screen rather than a boxed 85% of one. `overflow-hidden` has to beat
          the fullscreen preset's own scroll — the zoom surface pans, it does
          not scroll. */}
      <DialogContent
        mobileFullscreen
        className="flex h-[85vh] w-[90vw] max-w-5xl flex-col gap-0 overflow-hidden p-0 max-sm:overflow-y-hidden max-sm:p-0"
      >
        <DialogHeader className="border-b px-4 py-3 pr-14">
          <DialogTitle className="truncate text-sm font-medium">{label}</DialogTitle>
        </DialogHeader>
        <div className="min-h-0 flex-1">
          {open &&
            (kind === 'pdf' ? (
              <ReceiptPdfViewer src={src} title={label} />
            ) : (
              <ReceiptImageViewer src={src} alt={label} />
            ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
